import { useCallback } from 'react';
import { Object3D } from 'three';

import { useSmartWatchEditorState } from '../../../../../util/hooks/signals';
import { SetOutputSettingsCommand } from '../../../../js/commands/SetOutputSettingsCommand';
import { YaptideEditor } from '../../../../js/YaptideEditor';
import {
	GeantScoringOutput,
	isGeantOutput
} from '../../../../Simulation/Scoring/GeantScoringOutput';
import {
	ObjectSelectOptionType,
	ObjectSelectPropertyField
} from '../fields/ObjectSelectPropertyField';
import { PropertiesCategory } from './PropertiesCategory';

export function GeantOutputConfiguration(props: { editor: YaptideEditor; object: Object3D }) {
	const { object, editor } = props;
	const { state: watchedObject } = useSmartWatchEditorState(
		editor,
		object as unknown as GeantScoringOutput
	);

	const handleChangedDetector = useCallback(
		(v: ObjectSelectOptionType) => {
			editor.execute(
				new SetOutputSettingsCommand(
					editor,
					watchedObject.object,
					'detector',
					editor.detectorManager.getDetectorByUuid(v.uuid)
				)
			);
		},
		[editor, watchedObject]
	);

	const visibleFlag = isGeantOutput(watchedObject);

	return (
		<PropertiesCategory
			category='Output Configuration'
			visible={visibleFlag}>
			{visibleFlag && (
				<>
					<ObjectSelectPropertyField
						label='Detector'
						value={watchedObject.detector?.uuid ?? ''}
						options={editor.detectorManager.getDetectorOptions(value => {
							return (
								!editor.scoringManager.getTakenDetectors().includes(value.uuid) ||
								value.uuid === watchedObject.detector?.uuid
							);
						})}
						onChange={handleChangedDetector}
					/>
				</>
			)}
		</PropertiesCategory>
	);
}
